export const ROOT = "/admin/integration";
export const DKSH_PRODUCT_LIST = `${ROOT}/dksh/products`;
export const DKSH_PRODUCT_IMPORT = `${ROOT}/dksh/import-product`;
export const DKSH_INVOICE_LIST = `${ROOT}/dksh/invoices`;
export const DKSH_INVOICE_DETAIL = `${ROOT}/dksh/invoices/:uuid`;
export const PRIFE_CHECKOUT_LIST = `${ROOT}/prife/checkout`;
export const PRIFE_CHECKOUT_DETAIL = `${ROOT}/prife/checkout/:uuid`;

export const MASTER_LIST = `${ROOT}/master-list`;
export const MASTER_LIST_STOCKIST_ORDER_DETAIL = `${ROOT}/master-list/stockist/:mlUuid`;
export const MASTER_LIST_BRANCH_ORDER_DETAIL = `${ROOT}/master-list/branch/:mlUuid`;
export const MASTER_LIST_PWG_ORDER_DETAIL = `${ROOT}/master-list/pwg/:mlUuid`;
export const MASTER_LIST_IHQ_ORDER_DETAIL = `${ROOT}/master-list/international-hq/:mlUuid`;

export const SHIPPING_ORDER = `${ROOT}/shipping-order`;
export const SHIPPING_ORDER_MASTER_LIST = `${ROOT}/shipping-order/:uuid/master-list`;
export const SHIPPING_ORDER_MASTER_LIST_DETAIL = `${ROOT}/shipping-order/:uuid/master-list-detail/:mlUuid`;
export const SHIPPING_ORDER_DETAIL = `${ROOT}/shipping-order/:uuid/detail`;

export const DISPATCH_INSTRUCTION_LIST = `${ROOT}/dispatch-instruction`;
export const DISPATCH_INSTRUCTION_DETAIL = `${ROOT}/dispatch-instruction/:uuid`;

export const WARRANTY_CLAIM_INTEGRATION = `${ROOT}/claim`;

export const RECEIVE_TRANSFER_LIST = `${ROOT}/receive-transfer`;
export const RECEIVE_TRANSFER_DETAIL = `${ROOT}/receive-transfer/:uuid`;
export const STOCKOUT_ACTIVITIES = `${ROOT}/stockout-activities`;


export const PURCHASE_ORDER_LIST = `${ROOT}/purchase-order`;
export const PURCHASE_ORDER_DETAIL = `${ROOT}/purchase-order/:purchaseOrderUUID/`;
export const PURCHASE_ORDER_CREATE = `${ROOT}/purchase-order/new`;
